import { CustomBundle } from ".";
import { getLanguageFromFullLocale } from "../../lib/config";
import { TableColumns } from "../shared/crud/list";
import { mapRenderer, ReadOnlySwitchRenderer, StringRenderer } from "../shared/renderers/table";
import { getProtoTimestampAsDateStringSecond } from "../shared/utils";
import { BUNDLE_ALL_PRICE_TYPE_MESSAGE, messages } from "./EditBundle/messages";
import { BundlePriceType } from "./EditBundle/types";
import { tableHeaderMessages } from "./messages";

const HOURS_IN_DAY = 24;

export const tableColumns: TableColumns<CustomBundle> = {
  active: {
    renderer: ReadOnlySwitchRenderer,
  },
  ticker: {
    renderer: StringRenderer,
  },
  translationsList: {
    children: {
      name: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.length) return undefined;
          const current = v.find(t => t.locale === getLanguageFromFullLocale(intl.locale));
          return current?.name || v[0].name;
        }),
      },
    },
  },
  bundlePriceType: {
    renderer: mapRenderer(StringRenderer, (v, intl) => {
      //@ts-ignore
      const current = BUNDLE_ALL_PRICE_TYPE_MESSAGE[BundlePriceType[v]];
      return intl.formatMessage(current.label).toString();
    }),
  },
  promotionsList: {
    renderer: mapRenderer(StringRenderer, v => {
      if (!v || !v.length) return undefined;
      return v.toString();
    }),
  },
  extrasList: {
    renderer: mapRenderer(StringRenderer, v => {
      if (!v || !v.length) return undefined;
      return v.toString();
    }),
  },
  travelWindowsList: {
    renderer: mapRenderer(StringRenderer, (v, intl) => {
      if (!v || !v.length) return undefined;

      if (v.length > 1) {
        return intl.formatMessage(messages.multiple).toString();
      }

      const startDate = getProtoTimestampAsDateStringSecond(v[0]?.startDate);
      const endDate = getProtoTimestampAsDateStringSecond(v[0]?.endDate);
      return `${startDate} - ${endDate}`;
    }),
  },
  restrictions: {
    children: {
      minStay: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.minStay) return "-";
          return v.minStay.own
            ? intl.formatMessage(messages.bundleTypeOwn)
            : ((v.minStay.constant?.intValue ?? 0) / HOURS_IN_DAY).toString();
        }),
      },
      maxStay: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.maxStay) return "-";
          return v.maxStay.own
            ? intl.formatMessage(messages.bundleTypeOwn)
            : ((v.maxStay.constant?.intValue ?? 0) / HOURS_IN_DAY).toString();
        }),
      },
      minNotice: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.minNotice) return "-";
          return v.minNotice.own
            ? intl.formatMessage(messages.bundleTypeOwn)
            : v.minNotice.constant?.intValue.toString();
        }),
      },
      maxNotice: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.maxNotice) return "-";
          return v.maxNotice.own
            ? intl.formatMessage(messages.bundleTypeOwn)
            : v.maxNotice.constant?.intValue.toString();
        }),
      },
      closeToArrival: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.closeToArrival) return "-";
          return intl.formatMessage(messages.bundleTypeOwn);
        }),
      },
      closeToDeparture: {
        renderer: mapRenderer(StringRenderer, (v, intl) => {
          if (!v || !v.closeToDeparture) return "-";
          return intl.formatMessage(messages.bundleTypeOwn);
        }),
      },
    },
  },
  codesList: {
    renderer: mapRenderer(StringRenderer, v => {
      if (!v || !v.length) return undefined;
      return v.toString();
    }),
  },
};
